import { useGetSubscriptionQuery } from 'src/Redux/subscription-process/subscriptionApi'

export const useHasPlan = (): boolean => {
  const { data: subscription } = useGetSubscriptionQuery()

  return Boolean(
    subscription?.status === 'active' || subscription?.status === 'canceled',
  )
}
